import { Block } from 'ui-kit/blocks'
import { Heading } from 'ui-kit/typography'
import { Link } from 'ui-kit/actions/link/Link'
import { PricingPlans } from '../Plans'
import { PricingDivider } from '../Divider'
import { PricingGraph } from '../Graph'
import classes from './PricingPlatformFee.module.scss'

export function PricingPlatformFee() {
  return (
    <Block
      as={'section'}
      variant={'gradientMob'}
      pad={'baseMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <Heading as={'h1'} size={'xl'} center balance className={classes.title}>
        Simple Pricing: Platform Fee Plus a Capped Usage Fee. Nothing else.
      </Heading>
      <Heading as={'h2'} size={'lg'} center balance className={classes.caption}>
        Platform Fee Plans
      </Heading>
      <PricingPlans />
      <PricingDivider />
      <PricingGraph />
      <Link
        className={classes.button}
        asPageButton
        type='primary'
        href='mailto:hello@integration.app'
      >
        Get a Quote
      </Link>
    </Block>
  )
}
